{
  "dashboard": {
    "logoAlt": "Smart Word Labs",
    "nav": {
      "adminPortal": "Portal de administración",
      "enquiries": "Consultas",
      "signOut": "Cerrar sesión"
    },
    "hero": {
      "adminBadge": "Cuenta de administrador",
      "parentBadge": "Cuenta de padre/madre",
      "greeting": "Hola{{name}}",
      "subtitle": "Clases, facturación, progreso y mensajes del tutor para cada niño de tu familia.",
      "addChild": "Añadir niño",
      "form": {
        "childName": "Nombre del niño",
        "age": "Edad",
        "save": "Guardar"
      }
    },
    "plan": {
      "title": "Elige un plan mensual",
      "description": "Tu evaluación gratuita siempre está incluida. Un plan mensual desbloquea clases grupales en vivo, comentarios sobre tareas e informes de progreso CEFR.",
      "viewPlans": "Ver planes"
    },
    "studentMode": {
      "title": "Modo estudiante",
      "nextLesson": "Próxima clase {{datetime}} — un solo clic, sin inicio de sesión aparte para tu hijo.",
      "noLesson": "Aún no hay ninguna clase en vivo programada. Tu próxima sesión grupal aparecerá aquí.",
      "joinClass": "Unirse a la clase"
    },
    "scheduling": {
      "title": "Clases y programación",
      "bookAnother": "Reservar otra evaluación",
      "lessonFallback": "Clase",
      "reschedule": "Reprogramar",
      "rescheduleToast": {
        "title": "Solicitud de reprogramación enviada",
        "description": "Tu tutor confirmará un nuevo horario por correo electrónico."
      },
      "empty": {
        "title": "Reserva tu evaluación gratuita",
        "description": "Una llamada diagnóstica de 20 minutos con la Sra. Salma determina el nivel CEFR de tu hijo y su plan de aprendizaje. Es gratis y está incluida en cada cuenta.",
        "cta": "Reservar evaluación gratuita"
      }
    },
    "billing": {
      "title": "Facturación y suscripción",
      "pastDue": "Tu último pago falló. Actualiza tu tarjeta para mantener las clases activas.",
      "plan": "Plan",
      "noPlan": "Sin plan activo",
      "status": "Estado",
      "statusNone": "ninguno",
      "accessEnds": "El acceso finaliza",
      "renewsOn": "Se renueva el",
      "childrenEnrolled": "Niños inscritos",
      "manageSubscription": "Gestionar suscripción",
      "opening": "Abriendo…",
      "choosePlan": "Elegir un plan"
    },
    "progress": {
      "title": "Informes de progreso",
      "cefrLevel": "Nivel CEFR",
      "awaitingAssessment": "Pendiente de evaluación",
      "lessonsCompleted": "Clases completadas",
      "homeworkReviewed": "Tareas revisadas",
      "submitHomework": "Enviar tarea"
    },
    "homeworkFeedback": {
      "title": "Tareas y comentarios del tutor",
      "empty": "Aún no hay tareas enviadas."
    },
    "messages": {
      "title": "Mensajes de tu tutor",
      "empty": "Aún no hay mensajes. Tu tutor publicará notas de la clase aquí después de cada sesión."
    },
    "toasts": {
      "childAdded": "Perfil de niño añadido",
      "paymentReceived": {
        "title": "Pago recibido",
        "description": "Configurando tu plan — esto tarda unos segundos."
      },
      "portalUnavailable": "Portal no disponible",
      "portalError": "No se pudo abrir el portal de facturación"
    }
  },
  "homework": {
    "backToDashboard": "Volver al panel",
    "title": "Enviar tarea",
    "description": "Sube una grabación de lectura y las páginas de ejercicios. Los archivos se almacenan de forma privada y solo tu tutor puede verlos.",
    "form": {
      "lesson": "Clase",
      "selectLesson": "Selecciona una clase",
      "lessonFallback": "Clase",
      "noBookings": "Necesitas una clase reservada antes de poder enviar tareas.",
      "audioRecording": "Grabación de audio",
      "worksheet": "Hoja de ejercicios (PDF o imagen)",
      "uploading": "Subiendo…",
      "submit": "Enviar tarea"
    },
    "submissions": {
      "title": "Tus envíos",
      "audio": "Audio",
      "worksheet": "Hoja de ejercicios",
      "watchVideoFeedback": "Ver comentarios en video del tutor",
      "empty": "Aún no se ha enviado nada."
    },
    "errors": {
      "fileTooLarge": "El archivo de {{kind}} debe pesar menos de 25 MB",
      "chooseLesson": "Elige la clase a la que pertenece esta tarea",
      "attachFile": "Adjunta una grabación de audio o una hoja de ejercicios",
      "uploadFailed": "Error al subir el archivo",
      "openFileFailed": "No se pudo abrir el archivo"
    },
    "toasts": {
      "submitted": "Tarea enviada — tu tutor ha sido notificado"
    }
  },
  "messagesPage": {
    "backToPortal": "Volver al portal",
    "title": "Consultas del sitio web",
    "description": "Mensajes enviados a través del formulario de contacto. Solo tú puedes verlos.",
    "exportCsv": "Exportar CSV",
    "loading": "Cargando consultas…",
    "empty": "Aún no hay consultas.",
    "childAge": "edad del niño {{age}}",
    "status": {
      "handled": "Atendida",
      "new": "Nueva"
    },
    "actions": {
      "reopen": "Reabrir",
      "markHandled": "Marcar como atendida"
    },
    "csv": {
      "headers": {
        "received": "Recibido",
        "name": "Nombre",
        "email": "Correo electrónico",
        "whatsapp": "WhatsApp",
        "childAge": "Edad del niño",
        "subject": "Asunto",
        "message": "Mensaje",
        "status": "Estado"
      },
      "filename": "smart-word-labs-consultas-{{date}}"
    },
    "toasts": {
      "updateFailed": "No se pudo actualizar esta consulta.",
      "nothingToExport": "Todavía no hay consultas para exportar.",
      "exported_one": "Se exportó {{count}} consulta.",
      "exported_other": "Se exportaron {{count}} consultas."
    }
  },
  "admin": {
    "backToDashboard": "Volver al panel",
    "title": "Portal de administración",
    "description": "Pagos, reservas, remuneraciones y cuentas de usuario de Smart Word Labs.",
    "tabs": {
      "payments": "Pagos",
      "bookings": "Reservas",
      "payouts": "Remuneraciones",
      "users": "Usuarios"
    },
    "table": {
      "loading": "Cargando…",
      "clearFilters": "Borrar filtros",
      "details": "Detalles",
      "view": "Ver",
      "action": "Acción"
    },
    "payments": {
      "searchPlaceholder": "Buscar estudiante o tutor",
      "searchAriaLabel": "Buscar pagos por nombre de estudiante o tutor",
      "filterAriaLabel": "Filtrar por estado de pago",
      "filterPlaceholder": "Estado de pago",
      "statuses": {
        "all": "Todos los estados de pago",
        "unpaid": "Sin pagar",
        "paid": "Pagado",
        "refunded": "Reembolsado"
      },
      "columns": {
        "student": "Estudiante",
        "tutor": "Tutor",
        "programme": "Programa",
        "amount": "Importe",
        "payment": "Pago",
        "created": "Creado"
      },
      "empty": "Ningún pago coincide con estos filtros todavía.",
      "refund": "Reembolsar",
      "confirm": {
        "title": "¿Reembolsar este pago?",
        "description": "Esto emite un reembolso real a través de Stripe para <strong>{{name}}</strong> ({{amount}}) y marca la reserva como reembolsada. No se puede deshacer.",
        "fallbackName": "este estudiante",
        "cancel": "Cancelar",
        "confirm": "Reembolsar pago"
      },
      "toasts": {
        "success": "Reembolso emitido y la reserva se ha marcado como reembolsada.",
        "error": "No se pudo completar el reembolso."
      }
    },
    "bookings": {
      "status": "Estado",
      "from": "Desde",
      "to": "Hasta",
      "statuses": {
        "all": "Todos los estados",
        "pending": "Pendiente",
        "confirmed": "Confirmada",
        "completed": "Completada",
        "canceled": "Cancelada"
      },
      "columns": {
        "scheduled": "Programada",
        "student": "Estudiante",
        "tutor": "Tutor",
        "programme": "Programa",
        "status": "Estado",
        "payment": "Pago"
      },
      "empty": "Ninguna reserva coincide con estos filtros todavía.",
      "detail": {
        "title": "Detalles de la reserva",
        "description": "Registro completo de esta reserva de clase.",
        "student": "Estudiante",
        "studentEmail": "Correo del estudiante",
        "tutor": "Tutor",
        "programme": "Programa",
        "amount": "Importe",
        "scheduled": "Programada",
        "created": "Creada",
        "status": "Estado",
        "payment": "Pago",
        "refundedAt": "Reembolsada el",
        "meetingLink": "Enlace de la reunión",
        "stripePayment": "Pago en Stripe"
      }
    },
    "payouts": {
      "totalPending": "Total de pagos pendientes",
      "filterAriaLabel": "Filtrar remuneraciones por estado",
      "filterPlaceholder": "Estado",
      "statuses": {
        "all": "Todos los estados",
        "pending": "Pendiente",
        "paid": "Pagado"
      },
      "columns": {
        "tutor": "Tutor",
        "amount": "Importe",
        "payoutDate": "Fecha de pago",
        "status": "Estado"
      },
      "empty": "Todavía no se han registrado remuneraciones.",
      "markAsPaid": "Marcar como pagado",
      "toasts": {
        "success": "Remuneración marcada como pagada.",
        "error": "No se pudo actualizar esta remuneración."
      }
    },
    "users": {
      "filterAriaLabel": "Filtrar usuarios por rol",
      "filterPlaceholder": "Rol",
      "roles": {
        "all": "Todos los roles",
        "parent": "Padre/madre",
        "tutor": "Tutor",
        "admin": "Administrador"
      },
      "columns": {
        "name": "Nombre",
        "email": "Correo electrónico",
        "role": "Rol",
        "joined": "Se unió"
      },
      "empty": "Ningún usuario coincide con este filtro.",
      "viewTutor": "Ver tutor",
      "tutorFallback": "Tutor",
      "loadingTutor": "Cargando detalles del tutor…",
      "noTutorProfile": "No hay ningún perfil de tutor registrado.",
      "detail": {
        "hourlyRate": "Tarifa por hora",
        "commission": "Comisión",
        "active": "Activo",
        "onboardingSubmitted": "Incorporación enviada",
        "specialisation": "Especialización",
        "bio": "Biografía",
        "yes": "Sí",
        "no": "No"
      }
    }
  }
}
